<template>
  <!-- Desktop modal -->
  <base-modal
    v-if="!isMobile"
    name="basic-modal"
    :style="{ width: '560px' }"
    :visible="show"
    close-button
    close-outside
    @close="closeModal"
  >
    <content-skeleton v-if="loading" />

    <content
      v-else
      :is-update="isUpdate"
      :show="show"
      :item="item"
      @onSubmit="onSubmit"
    />
  </base-modal>

  <!-- Mobile bottom sheet -->
  <bottom-sheet
    v-else
    :visible="show"
    :show-close-button="true"
    :close-on-backdrop="true"
    @close="closeModal"
  >
    <content-skeleton v-if="loading" />

    <content
      v-else
      :is-update="isUpdate"
      :show="show"
      :item="item"
      @onSubmit="onSubmit"
    />
  </bottom-sheet>
</template>

<script setup>
import { computed, watch, ref, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'

import BaseModal from '@emcd-shared/base-modal'
import BottomSheet from '@/widgets/ModalPaymentLink/ui/components/BottomSheet.vue'
import ContentSkeleton from '@/widgets/ModalPaymentLink/ui/components/ContentSkeleton.vue'
import Content from '@/widgets/ModalPaymentLink/ui/components/Content.vue'

import { APP_GETTERS } from '@/shared/constants/store-constants/app'
import segmentService from '@/shared/services/segment.service'
import { ANALYTICS_EVENT_TYPE } from '@/packages/auth-service/requiredUserAction/shared/utils/analytics'

const isMobile = ref(false)

function checkMobile() {
  isMobile.value = window.innerWidth < 640
}

onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  item: {
    type: Object,
    default: () => ({}),
  },
  isUpdate: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['update:modelValue', 'onSubmit', 'resetUpdate'])

const store = useStore()

const show = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits('update:modelValue', value)
  },
})

const loading = computed(() => store.getters[APP_GETTERS.loading])

function closeModal() {
  show.value = false
}

function onSubmit(formData) {
  emits('onSubmit', formData)

  segmentService.trackNewEvent(ANALYTICS_EVENT_TYPE.CLICK, {
    event: ANALYTICS_EVENT_TYPE.CLICK,
    page: 'payment_links',
    screen: 'payment_link_form',
    button_name: 'create_and_get_link',
  })
}

watch(show, (value) => {
  if (!value) {
    emits('resetUpdate', false)
  }
})
</script>
